//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('oeeStateEquipments', {
//        templateUrl: 'views/components/views/oeeStateEquipments/oeeStateEquipments.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'oeeStateEquipmentsService', function ($stateParams, oeeStateEquipmentsService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let argType = $stateParams.argtype;
//            let argValue = $stateParams.argvalue;

//            vm.model = {
//                itemsListEquipments: []
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALL

//            async function loadEquipments() {
//                vm.model.itemsListEquipments = await oeeStateEquipmentsService.listEquipments({
//                    argtype: argType,
//                    argvalue: argValue
//                });
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                loadEquipments();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
